/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import DeliveryModel from 'cio/models/delivery';
import MessageSettingsService from 'cio/services/message-settings';
import DeliveryDetailModel from 'cio/models/delivery-detail';

interface DeliveryRedeliverButtonArgs {
  delivery: DeliveryModel;
  detail: DeliveryDetailModel | null;
  isDisabled?: boolean;
  hasReadOnlyPermission: boolean;
  buttonClassNames?: string;
  confirmAction: ({ tracked, overrideLimit }: { tracked: boolean; overrideLimit?: boolean }) => unknown;
}

export default class DeliveryRedeliverButton extends Component<DeliveryRedeliverButtonArgs> {
  @service messageSettings!: MessageSettingsService;

  @tracked showModal = false;
  @tracked trackedChoice = true;
  @tracked overrideLimit = true;

  get buttonClassNames() {
    return this.args.buttonClassNames ?? 'fly-btn fly-btn--sm';
  }

  get tooltipText() {
    if (this.args.delivery.forgotten) {
      return "Can't resend messages to GDPR-suppressed customers";
    } else if (this.hideBody) {
      return "Can't resend message because message retention was disabled";
    }

    return '';
  }

  get hideBody() {
    return this.args.detail?.hideBody ?? false;
  }

  submitTask = dropTask(async () => {
    let options: { tracked: boolean; overrideLimit?: boolean } = { tracked: this.trackedChoice };

    if (this.messageSettings.isMessagingLimitEnabled) {
      options.overrideLimit = this.overrideLimit;
    }

    await this.args.confirmAction(options);
    this.resetToDefaultState();
  });

  @action
  closeModal() {
    this.resetToDefaultState();
  }

  private resetToDefaultState() {
    this.showModal = false;
    this.trackedChoice = true;
  }
}
